import React, { Component } from 'react';
import ConfigMenu from './../config/ConfigMenu';
import './Sweetroot.scss';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { LevelToEtape, SuccessPage, ErrorPage, SweetStepper, UnderStepperLibelle, Footer } from '../settings';
import TextField from '@material-ui/core/TextField';
import Select from './Select';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./../stripe/CheckoutForm";
import PointdeRetrait from './../config/PointdeRetrait'
import ReactLoading from 'react-loading';
var validator = require("email-validator");

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// loadStripe is initialized with your real test publishable API key.
const promise = loadStripe(process.env.REACT_APP_STRIPE_PK);
var _PointdeRetrait = null;
const SansGarnitureRefCode = '50'
var _GarniturePrice = 0.4

export default class Sweetroot extends Component {

    logo = require('../img/Logo.png')
    The = require('../img/Thenoirvert.png')

    plusimg = require('../img/plus.png')
    moinsimg = require('../img/moins.png')

    parfums = require('../img/Parfums.png')
    parfumschef = require('../img/Parfumschef.png')

    Niveausucre = require('../img/Niveausucre.png')

    cardItem = () => ({
        id: Date.now(),
        ice: true,
        boisson: null,
        taille: null,
        the: null,
        parfums: [],
        sucre: 0,
        garnitures: [],
        quantitee: 1
    })
    getCurrentCardItem = () => this.state.card.find(cx => cx.id === this.state.currentCardItem)
    getCardItem = (id) => this.state.card.find(cx => cx.id === id)
    removeCardItem = (id) => this.state.card = this.state.card.filter(cx => cx.id !== id)
    getBoisson = () => ConfigMenu.getBoisson(this.getCurrentCardItem().boisson)
    getTaille = () => ConfigMenu.getTaille(this.getCurrentCardItem().boisson, this.getCurrentCardItem().taille)
    getThe = () => ConfigMenu.getThe(this.getCurrentCardItem().boisson, this.getCurrentCardItem().taille, this.getCurrentCardItem().the)


    constructor(props) {
        super(props)
        this.state = {
            pointderetrait: null,
            loading: true,
            level: 0,
            currentCardItem: null,
            card: [],
            customer: {
                nom: '',
                prenom: '',
                mail: ''
            },
            customerFormError: {
                nom: '',
                prenom: '',
                mail: ''
            }
        }
    }

    componentDidMount() {
        this.GetPdr();
    }

    componentDidUpdate() {

    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (this.state.level === 4)
            if (this.state.editcardMode || this.Editmode())
                if (this.getCurrentCardItem().parfums.length !== 0) {
                    var test = this.getCurrentCardItem().parfums
                        .reduce((pv, cu) => pv || this.getTaille().parfums.map(x => x.ref).includes(cu), false)
                    if (!test)
                        this.getCurrentCardItem().parfums = []
                    var numberToShift = this.getCurrentCardItem().parfums.length - this.getCurrentCardItem().boisson.maxparfum

                    while (numberToShift > 0) {
                        this.getCurrentCardItem().parfums.shift()
                        numberToShift--
                    }
                }
        return null
    }
    render() {
        if (this.state.paymentstatus === "OK") return (<SuccessPage />)
        if (this.state.paymentstatus === "KO") return (<ErrorPage />)
        if (this.state.loading) return (<div className="sweetroot"><ReactLoading type="spin" color="#0e2819" className="ReactLoading" height={150} width={150} /></div>)

        else
            return (
                <>
                    <div className="sweetroot">
                        <SweetStepper state={this.state} StepClickCallBack={(i) => {
                            var _li = LevelToEtape.map(x => x.number).indexOf(i)
                            if (_li < this.state.level && this.state.level < 7)
                                this.GotoLevel(_li)
                        }} />

                        <UnderStepperLibelle level={this.state.level} />
                        <div className="renderProcess">
                            {this.renderProcess()}
                        </div>
                        <Footer quantity={this.state.card.map(x => x.quantitee).reduce((a, b) => a + b, 0)}
                            totale={this.calculprixTotale().toFixed(2)}
                            level={this.state.level}
                            allowReturnTocard={this.state.allowReturnTocard}
                            RetourCallback={() => {
                                this.GotoLevel(this.state.level - 1)

                            }}
                            ShopCallback={() => {
                                this.GotoLevel(7)
                            }}
                        />
                    </div>
                </>)
    }

    Editmode() {
        return this.getCurrentCardItem().selectionlevel > this.state.level
    }
    renderProcess() {
        if (this.state.level === 0) // Choix du point de retrait
            return (<>
                <div className="pointderetrait">
                    <ul>
                        {_PointdeRetrait.map((x, i) => {
                            return (
                                <li key={`pdr${i}`} >
                                    <div className="header">{x.name}</div>
                                    <div className="address">{x.address}</div>
                                    {x.comandAuthorize ?
                                        <button onClick={() => {
                                            ConfigMenu.init(x.ConfigMenu)
                                            _GarniturePrice = ConfigMenu.Garnitures.map(x => x.prix)[0] ?? _GarniturePrice
                                            let nci = this.cardItem()
                                            this.setState({
                                                pointderetrait: x,
                                                level: 1,
                                                currentCardItem: nci.id,
                                                card: [nci],
                                            });
                                        }}>Choisir</button>
                                        : <div className="closed">FERMÉ</div>}
                                </li>
                            )
                        })
                        }
                    </ul>
                </div>
            </>)
        if (this.state.level === 1) // Choix de la boisson
            return (<>
                <div className="formule">
                    <div className="frow">
                        <div className={"left"}>
                            <div className="content" disabled={ConfigMenu.Boissons[0].taille.every(ex => !ex.disponible)}>
                                <img src={ConfigMenu.Boissons[0].imgsp} alt="" onClick={() => {
                                    this.getCurrentCardItem().boisson = ConfigMenu.Boissons[0].ref
                                    this.setState({ level: 2, });
                                }} />
                                <div className={"prices"}> {ConfigMenu.Boissons[0].taille.map(t => {
                                    return <div className={`${t.name} ${ConfigMenu.Boissons[0].ref}`} key={`tid${t.ref}`}>{t.prix.toFixed(2) + "€"}</div>
                                })}</div>
                            </div>
                        </div>
                        <div className={"right"}>
                            <div className="content" disabled={ConfigMenu.Boissons[1].taille.every(ex => !ex.disponible)}>
                                <img src={ConfigMenu.Boissons[1].imgsp} alt="" onClick={() => {
                                    this.getCurrentCardItem().boisson = ConfigMenu.Boissons[1].ref
                                    this.setState({ level: 2, });
                                }} />
                                <div className={"prices"}> {ConfigMenu.Boissons[1].taille.map(t => {
                                    return <div className={`${t.name} ${ConfigMenu.Boissons[1].ref}`} key={`tid${t.ref}`}>{t.prix.toFixed(2) + "€"}</div>
                                })}</div>
                            </div>
                        </div>

                    </div>
                    <div className="frow">
                        <div className={"left"}>
                            <div className="content" disabled={ConfigMenu.Boissons[2].taille.every(ex => !ex.disponible)}>
                                <img src={ConfigMenu.Boissons[2].imgsp} alt="" onClick={() => {
                                    this.getCurrentCardItem().boisson = ConfigMenu.Boissons[2].ref
                                    this.setState({ level: 2, });
                                }} />
                                <div className={"prices"}> {ConfigMenu.Boissons[2].taille.map(t => {
                                    return <div className={`${t.name} ${ConfigMenu.Boissons[2].ref}`} key={`tid${t.ref}`}>{t.prix.toFixed(2) + "€"}</div>
                                })}</div>
                            </div>
                        </div>
                        <div className={"right"}>
                            <div className="content" disabled={ConfigMenu.Boissons[3].taille.every(ex => !ex.disponible)}>
                                <img src={ConfigMenu.Boissons[3].imgsp} alt="" onClick={() => {
                                    this.getCurrentCardItem().boisson = ConfigMenu.Boissons[3].ref
                                    this.setState({ level: 2, });
                                }} />
                                <div className={"prices"}> {ConfigMenu.Boissons[3].taille.map(t => {
                                    return <div className={`${t.name} ${ConfigMenu.Boissons[3].ref}`} key={`tid${t.ref}`}>{t.prix.toFixed(2) + "€"}</div>
                                })}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>)

        if (this.state.level === 2) // Choix de la taille
        {
            let boissonChoisie = this.getBoisson()
            return (<>
                <div className="taille">
                    {
                        boissonChoisie.taille
                            .map((x, i) => {
                                return (
                                    <div
                                        disabled={!x.disponible}
                                        key={`tlkey${i}`}
                                        className={"formula" + boissonChoisie.number}
                                        onClick={() => {
                                            this.getCurrentCardItem().taille = x.ref
                                            this.setState({ level: 3 });
                                        }}><div className="incaseofdisable">
                                            <div className="header">{x.name}</div>
                                            <div className="price">{x.prix.toFixed(2)} €</div>
                                        </div>
                                    </div>
                                )
                            })
                    }
                </div>
            </>)
        }
        if (this.state.level === 3) //Choix The noir Thé vert
        {
            let TailleChoisie = this.getTaille()

            return (<>
                <div className="thenoirvert">
                    {TailleChoisie.The.map((x, i) => {
                        return (
                            <div
                                disabled={!x.disponible}
                                key={`imgthe${i}`}
                                className={x.name} onClick={() => {
                                    this.getCurrentCardItem().the = x.ref
                                    this.setState({ level: 4 });
                                }}>
                                <div className="incaseofdisable">
                                    <img key={`imgthe${i}`} src={x.img} className={x.name} alt="" />
                                    <span>{x.name}</span>
                                </div>
                            </div>
                        )
                    })}

                </div>
            </>)
        }
        if (this.state.level === 4) // Choix du parfums
        {
            let TailleChoisie = this.getTaille()
            let boissonChoisie = this.getBoisson()
            return (<>
                <div className="parfumetsucre">
                    <div className="parfums">
                        <div className={`content ${boissonChoisie.name}`}>
                            <h2>{boissonChoisie.HeaderChoice}</h2>
                            <h3>{`(${boissonChoisie.maxparfum} max)`}</h3>
                            <ul >
                                {
                                    TailleChoisie.parfums.map((p, i) => {
                                        return (
                                            <li key={`pf${i}`}
                                                disabled={!p.disponible}
                                                className={this.getCurrentCardItem().parfums.some(px => px === p.ref) ? "sel" : ""}
                                                onClick={() => this.parfumclick(p)}>
                                                <span className="title">
                                                    {p.displayName}
                                                </span>
                                                <div className="description">
                                                    {p.content?.join(' - ')}
                                                </div>
                                            </li>
                                        )
                                    })}
                            </ul>
                        </div>
                    </div>
                    <button className="parfumvalidate" onClick={() => {
                        if (this.getCurrentCardItem().parfums.length < boissonChoisie.maxparfum) {
                            alert("Attention, vous devez choisir " + boissonChoisie.maxparfum + " parfums")
                            return;
                        }
                        this.setState({ level: 5 });
                    }}>Validez</button>
                </div>
            </>)
        }
        if (this.state.level === 5) // Choix du sucre
        {
            let sref0 = ConfigMenu.getSucrebyValue(0);
            let sref30 = ConfigMenu.getSucrebyValue(30);
            let sref50 = ConfigMenu.getSucrebyValue(50);
            let sref100 = ConfigMenu.getSucrebyValue(100);
            return (<>
                <div className="parfumetsucre">
                    <div className="sucre">
                        <div className="contentsugar">
                            <h2>Choisissez le niveau de sucre</h2>
                            <div className="sucrespiner">

                                <div className="div-table">
                                    <div className="div-table-row">
                                        <div disabled={!sref0.disponible} className="div-table-col" align="center">
                                            <div className="incaseofdisable">
                                                <div className={"CircularProgressbardiv " + (this.getCurrentCardItem().sucre === sref0.ref ? "cpbselected" : "")}
                                                    onClick={() => {
                                                        this.getCurrentCardItem().sucre = sref0.ref
                                                        this.setState({ updatorStateField: sref0.ref })
                                                    }}>
                                                    <CircularProgressbar value={0} text="0%" />
                                                </div>
                                            </div>
                                        </div>
                                        <div disabled={!sref30.disponible} className="div-table-col">
                                            <div className="incaseofdisable">
                                                <div className={"CircularProgressbardiv " + (this.getCurrentCardItem().sucre === sref30.ref ? "cpbselected" : "")}
                                                    onClick={() => {
                                                        this.getCurrentCardItem().sucre = sref30.ref
                                                        this.setState({ updatorStateField: sref30.ref })
                                                    }}>
                                                    <CircularProgressbar value={30} text="30%" />
                                                </div>
                                            </div></div>
                                        <div disabled={!sref50.disponible} className="div-table-col">
                                            <div className="incaseofdisable">
                                                <div className={"CircularProgressbardiv " + (this.getCurrentCardItem().sucre === sref50.ref ? "cpbselected" : "")}
                                                    onClick={() => {
                                                        this.getCurrentCardItem().sucre = sref50.ref
                                                        this.setState({ updatorStateField: sref50.ref })
                                                    }}>
                                                    <CircularProgressbar value={50} text="50%" />

                                                </div>
                                            </div></div>
                                        <div disabled={!sref100.disponible} className="div-table-col">
                                            <div className="incaseofdisable">
                                                <div className={"CircularProgressbardiv " + (this.getCurrentCardItem().sucre === sref100.ref ? "cpbselected" : "")} onClick={() => {
                                                    this.getCurrentCardItem().sucre = sref100.ref
                                                    this.setState({ updatorStateField: sref100.ref })
                                                }}>
                                                    <CircularProgressbar value={100} text="100%" />

                                                </div>
                                            </div></div>
                                    </div>
                                    <div className="div-table-row tablefooter">
                                        <div disabled={!sref0.disponible} className="div-table-col"><div>Sans Sucre ajouté</div></div>
                                        <div disabled={!sref30.disponible} className="div-table-col"><div>Léger</div></div>
                                        <div disabled={!sref50.disponible} className="div-table-col"><div>Moyen</div></div>
                                        <div disabled={!sref100.disponible} className="div-table-col"><div>Beaucoup</div></div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="parfumvalidate" onClick={() => {
                        if (this.getCurrentCardItem().sucre === 0)
                            this.getCurrentCardItem().sucre = sref0.ref
                        this.setState({ level: 6 });

                    }}>Validez</button>
                </div>
            </>)
        }
        if (this.state.level === 6) // Choix Garnitures
        {
            return (<>
                <div className="Garnitures">
                    <div className="garniturecontent">
                        <ul>
                            {ConfigMenu.Garnitures.map((g, i) => {
                                if (this.getCurrentCardItem().garnitures.filter(x => x === g.ref).length === 0)
                                    return (<li disabled={!g.disponible} key={`gr${i}`} className="" onClick={() => this.garnitureclick(g)}>{g.name}</li>)
                                else
                                    if (g.ref === SansGarnitureRefCode)
                                        return (<li key={`gr${i}`} disabled={!g.disponible} className="sel" onClick={() => this.garnitureclick(g)}>{g.name}</li>)
                                    else
                                        return (
                                            <li key={`gr${i}`} disabled={!g.disponible} className="sel" >
                                                <div>
                                                    <label> {g.name}</label>
                                                    <div className="gquantite">
                                                        <img src={this.moinsimg} alt="" onClick={() => this.garnitureclickmoins(g)} />
                                                        {this.getCurrentCardItem().garnitures.filter(x => x === g.ref).length}
                                                        <img src={this.plusimg} alt="" onClick={() => this.garnitureclickplus(g)} />
                                                    </div>
                                                </div>
                                            </li>
                                        )

                            })}
                        </ul>
                        <div className="bottomg">
                            1 incluse
                        </div>
                        <div className="bottomg">
                            {`+${_GarniturePrice.toFixed(2)}€ par supplément (3max)`}
                        </div>
                    </div>
                    {ConfigMenu.Glacons.disponible && <div className="ice" >

                        <label className="switch">
                            <input type="checkbox" onClick={() => {
                                this.getCurrentCardItem().ice = !this.getCurrentCardItem().ice
                                this.setState({ updatorStateField: this.getCurrentCardItem().ice })
                            }
                            } defaultChecked={this.getCurrentCardItem().ice}></input>
                            <span className="slider round"></span>
                        </label>
                        <span>{this.getCurrentCardItem().ice ? "Avec glaçon" : "Sans glaçon"}</span>

                    </div>}
                    <button className="validate" onClick={() => {

                        if (this.getCurrentCardItem().garnitures.length === 0) {
                            this.getCurrentCardItem().garnitures.push(SansGarnitureRefCode)
                        }
                        this.setState({ level: 7 })
                    }}>Validez</button>
                </div>
            </>)
        }
        if (this.state.level === 7) // Validez panier ou Rajouter Sweethé
            return (<>
                <div className="laststep">
                    {
                        this.state.card.length > 0 &&
                        <>
                            <div className="buttons">
                                <button className="validate new" onClick={() => {
                                    let nci = this.cardItem()
                                    this.setState({
                                        editcardMode: false,
                                        level: 1,
                                        currentCardItem: nci.id,
                                        card: [...this.state.card, nci],
                                        allowReturnTocard : true,
                                    });
                                }}>Ajouter</button>
                                <button className="validate new" onClick={() => {
                                    this.setState({
                                        editcardMode: !this.state.editcardMode,
                                        allowReturnTocard : true,
                                    });
                                }}>{this.state.editcardMode ? "Annuler" : "Modifier"}</button>
                            </div>
                            <div className="card selection">
                                {this.renderSelection()}
                            </div>

                            <div className="validate card">
                                <button onClick={async () => {
                                    await this.GetPdr();
                                    this.GotoLevel(8)
                                }}>Commander</button>
                            </div>

                        </>}
                </div>
            </>)
        if (this.state.level === 8) //Paiement
            return (<div className="laststep">{

                this.state.card.length > 0 && !this.state.ErrorloadingPayment &&
                <div className="customer">
                    <div className="Title">
                        <h2>C'est bientôt fini...</h2>
                        <img className="wink" src={require('./../img/wink.png')} alt="" />
                    </div>
                    <div className="infoscustomer">
                        <div className="nom">
                            <TextField id="filled-basic1" label="Email pour la réservation" variant="outlined"
                                name="customername"
                                placeholder="sweethé@cestbon.com"
                                onChange={(e) => {

                                    if (validator.validate(e.target.value)) {
                                        this.setState({ customer: { nom: e.target.value }, customerFormError: { nom: '' } })
                                    }
                                    else {
                                        this.setState({ customer: { nom: null }, customerFormError: { nom: 'Email obligatoire' } })

                                    }
                                    this.state.customer.nom = e.target.value;
                                }
                                }
                                error={this.state.customerFormError.nom.length !== 0}
                                helperText={this.state.customerFormError.nom}
                                InputProps={{
                                    startAdornment: <img className="user" src={require('./../img/user.png')} alt="" />
                                }}
                            />

                        </div>
                        <div className="heure">
                            <Select
                                InputLabel="heure"
                                items={this.state.pointderetrait.commanddeliverytime.map(x => {
                                    x.text = x.humanize
                                    return x;
                                })}
                                Callback={e => {
                                    var d = new Date()
                                    var delivery = new Date(d.getTime() + e * 60000)
                                    this.setState({ deliverytime: delivery.toISOString() })
                                }}></Select>
                        </div>
                    </div>

                    {this.state.deliverytime && this.state.customer.nom && !this.state.ErrorloadingPayment && <Elements stripe={promise}>
                        <CheckoutForm data={{
                            customer: this.state.customer.nom,
                            deliverytime: this.state.deliverytime,
                            pointderetrait: this.state.pointderetrait,
                            card: this.cardTransfomer(),
                        }} Callback={status => {
                            this.setState({ paymentstatus: status })

                        }}
                            errorCallBack={err => {
                                console.error(err)
                                this.setState({
                                    ErrorloadingPayment: true
                                })
                            }
                            } />
                    </Elements>}
                </div>
            }
                {this.state.ErrorloadingPayment &&
                    <div className="ErroriniPayment">
                        <div>Une erreur lors du chargement du paiement à été rencontrée
                        </div>
                        <div>Veuillez recharger la page
                        </div>
                    </div>
                }
                {
                    this.state.card.length === 0 &&
                    <>
                        <div className="emptycard">
                            <h2>Votre panier est vide</h2>
                            <div onClick={() => window.location.href = '/'} >Retour à l'accueil</div>
                            <div className="RepCom" onClick={() => this.GotoLevel(this.getCurrentCardItem().selectionlevel)}>Reprendre la commande</div>
                        </div>
                    </>

                }</div>)
        return (<></>)
    }
    renderSelection() {
        return (
            <>
                <h2>Récapitulatif</h2>
                <div className="contentTable">

                    {
                        this.state.card.map((x, i) => {
                            return (
                                <div className="carditem" key={`cardi${i}`}>
                                    {this.renderCarditem(x, i)}
                                </div>
                            )
                        })
                    }
                    <div className="carditem">
                        <div className="tablecell">
                        </div>
                        <div className="tablecell">
                        </div>
                        <div className="tablecell">
                            <div></div>
                            <div>Frais de service</div>
                        </div>
                        <div className="tablecell">
                            <span>{this.calculfrais().toFixed(2) + "€"}</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    renderCarditem(item) {
        let BoissonChoisie = ConfigMenu.getBoisson(item.boisson)
        let TailleChoisie = ConfigMenu.getTaille(item.boisson, item.taille)
        let TheChoisie = ConfigMenu.getThe(item.boisson, item.taille, item.the)
        let getParfum = (ref) => ConfigMenu.getParfum(item.boisson, item.taille, ref)
        let getParfums = () => item.parfums.map(x => getParfum(x))
        const getSucre = () => ConfigMenu.getSucrebyRef(item.sucre)

        return (
            <>

                {this.state.editcardMode &&
                    <div className="tablecell">
                        <input type="radio" name="selectitem" className="iradio" onClick={() => {
                            this.setState({ level: 1, currentCardItem: item.id })
                        }} />
                    </div>
                }
                {!this.state.editcardMode &&
                    <>
                        <div className="tablecell">

                            <img src={this.plusimg} alt="+" onClick={() => {
                                this.getCardItem(item.id).quantitee++
                                this.setState({ updatorStateField: Date.now() })
                            }} />
                            <img src={this.moinsimg} alt="-" onClick={() => {
                                this.RemoveOneItemClick(item.id)
                            }} />

                            <div />
                        </div>

                        <div className="tablecell">
                            <span>{item.quantitee}</span>
                        </div>
                    </>
                }
                <div className="tablecell">
                    <div>{`${TailleChoisie.name} ${BoissonChoisie.name}`}</div>
                    <div>{TheChoisie.name}</div>
                    <div>{getParfums().map(x => x.displayName).join(', ')}</div>
                    <div>{ConfigMenu.groupby(item.garnitures).map(x => x.name + (x.count > 1 ? ` (x${x.count})` : "")).join(', ')}</div>
                    <div>{`${getSucre().value}% sucre ${item.ice ? "Avec glaçon" : "Sans glaçon"}`}</div>
                </div>
                <div className="tablecell">
                    <span>{this.calculprix(item).toFixed(2)} €</span>
                </div>
            </>
        )
    }
    GetPdr() {
        this.setState({ loading: true });
        PointdeRetrait.getstate().then(pdr => {
            _PointdeRetrait = pdr;
            this.setState({ loading: false });
        });
    }
    garnitureclick(g) {
        var _g = this.getCurrentCardItem().garnitures
        // SI Sans Garniture on passe tous les count a 0
        if (g.ref === SansGarnitureRefCode)
            _g = [ConfigMenu.getGarniture(SansGarnitureRefCode).ref]
        else {
            //on verifie la quantité totale de garniture
            if (_g.length >= 4) {
                alert("Désolé, votre Sweethé ne peut pas contenir plus de 4 garnitures")
            }
            else {
                _g = _g.filter(gx => gx !== SansGarnitureRefCode)
                _g.push(g.ref)
            }
        }
        this.getCurrentCardItem().garnitures = _g
        this.setState({ updatorStateField: Date.now() });
    }
    garnitureclickmoins(g) {
        var _g = this.getCurrentCardItem().garnitures

        let i = _g.indexOf(g.ref)
        if (i > -1)
            _g.splice(i, 1)

        this.getCurrentCardItem().garnitures = _g
        this.setState({ updatorStateField: Date.now() });
    }
    garnitureclickplus(g) {
        var _g = this.getCurrentCardItem().garnitures
        if (_g.length >= 4)
            alert("Désolé, votre Sweethé ne peut pas contenir plus de 4 garnitures")
        else {
            _g = _g.filter(gx => gx !== SansGarnitureRefCode)
            _g.push(g.ref)
        }
        this.getCurrentCardItem().garnitures = _g
        this.setState({ updatorStateField: Date.now() });
    }
    GotoLevel(i) {
        this.setState({ level: i })
    }
    parfumclick(p) {
        let _p = this.getCurrentCardItem().parfums

        //SI le Parfum est deja la on le vire
        if (this.getCurrentCardItem().parfums.some(px => px === p.ref)) {
            _p = this.getCurrentCardItem().parfums.filter(px => px !== p.ref)
        }
        else {
            if (this.getCurrentCardItem().parfums.length >= this.getBoisson().maxparfum)
                this.getCurrentCardItem().parfums.shift()
            _p = [...this.getCurrentCardItem().parfums, p.ref]
        }
        this.getCurrentCardItem().parfums = _p
        this.setState({
            updatorStateField: _p.length
        })
    }
    calculprix(item) {
        let BoissonChoisie = ConfigMenu.getBoisson(item.boisson)
        if (BoissonChoisie) {
            let TailleChoisie = ConfigMenu.getTaille(item.boisson, item.taille)
            if (TailleChoisie) {
                let _numberOfGarniture = item.garnitures.length;
                return _numberOfGarniture <= 1 ? (TailleChoisie.prix * item.quantitee) : ((TailleChoisie.prix + _GarniturePrice * (_numberOfGarniture - 1)) * item.quantitee)
            }
            else
                return 0
        }
        else
            return 0
    }
    calculprixTotaleSansFrais = () => this.state.card.map(x => this.calculprix(x)).reduce((a, b) => a + b, 0);

    calculfrais() {
        if (this.state.pointderetrait) {
            let total = this.calculprixTotaleSansFrais();
            let frais = this.state.pointderetrait.taxe.pourcent * total + this.state.pointderetrait.taxe.constante
            return frais
        }
        else return 0;
    }
    calculprixTotale = () => this.calculprixTotaleSansFrais() + this.calculfrais()
    RemoveOneItemClick(id) {

        if (this.getCardItem(id).quantitee > 1) {
            this.getCardItem(id).quantitee--
            this.setState({ updatorStateField: Date.now() })
        }
        else {
            if (window.confirm("Voulez vous supprimer ce sweethé de votre panier ?")) {
                this.removeCardItem(id)
                this.setState({ updatorStateField: Date.now() })
            }
        }
    }
    cardTransfomer() {
        let cx = JSON.parse(JSON.stringify(this.state.card));
        cx.forEach(x => {
            x.ice = x.ice ? ConfigMenu.Glacons.ref : ConfigMenu.SansGlacons.ref
        });

        return cx;
    }

}